import script from "./ManageUnit.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageUnit.vue?vue&type=script&setup=true&lang=js"

import "./ManageUnit.vue?vue&type=style&index=0&id=c561dcb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c561dcb8"]])

export default __exports__